import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { useTranslation } from 'react-i18next';
import useProduct from 'hooks/useProduct';
import guava from './guava-colored.svg';
import guavaEvp from './guava-evp.svg';

const Wrapper = styled('img')`
  max-width: 100%;
  max-height: 100%;
  display: block;
`;

const Logo = ({ src, ...rest }) => {

  const { t } = useTranslation('common');

  const isEvp = useProduct() === 'evp';

  const defaultAlt = isEvp ? 'GuavaEVP' : t('common:guavahr');

  return (
    <Wrapper
      src={src || (isEvp ? guavaEvp : guava)}
      alt={src ? undefined : defaultAlt}
      {...rest}
    />
  );
};

Logo.propTypes = {
  src: PropTypes.string,
};

export default Logo;
